import React, { useState, useContext, useEffect } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

const Filter = (props) => {
  const options = ["All", "Cocks", "Hens"];
  const defaultOption = options[0];

  const filterStyle = {
    padding: "10px",
  };
  const filterStyleSelected = {
    textDecoration: "underline red",
    padding: "10px",
  };

  return (
    <div
      style={{
        fontWeight: "bold",
        padding: "10px",
        textAlign: "left",
        width: "200px",
      }}
    >
      Filter:
      <Dropdown
        options={options}
        onChange={(event) => props.FilterSelected(event)}
        value={props.SelectedValue}
        placeholder="Select an option"
      />
    </div>
  );
};

export default Filter;
